import * as React from "react";
import { Grid, Box, List, Chip, ListItem, ListItemText } from "@mui/material";
import SummarizeIcon from "@mui/icons-material/Summarize";

// IMPORT CSS
import "../theme/style.scss";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function TemplateSelection(props: any) {
  const {
    templates,
    handleTemplateClick,
    defaultTemplate,
    setDefaultTemplate,
  } = props;

  return (
    <>
      <React.Fragment>
        {/* <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop> */}

        <Grid>
          <Box>
            <List>
              {templates?.map((item: any, index) => {
                return (
                  <ListItem
                    className={
                      defaultTemplate === item?.value
                        ? "billing-list-data selected"
                        : "billing-list-data"
                    }
                    disablePadding
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        cursor: "pointer",
                      }}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleTemplateClick(item);
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <SummarizeIcon className="icon-design-inpopup" />
                        <ListItemText primary={<b>{item?.label}</b>} />
                      </Box>
                    </Box>
                    <Box>
                      {defaultTemplate === item?.value ? (
                        <Chip color="primary" label="Selected" />
                      ) : (
                        <FormControlLabel
                          label="Default"
                          control={
                            <Checkbox
                              checked={defaultTemplate === item?.value}
                              value={item?.value}
                              onChange={(event) => {
                                event.stopPropagation();
                                setDefaultTemplate(item?.value);
                              }}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                        />
                      )}
                    </Box>
                  </ListItem>
                );
              })}
            </List>
          </Box>
        </Grid>
      </React.Fragment>
    </>
  );
}
